import React from "react";
import PolicyEmbed from "./PolicyEmbed";

export default function PrivacyPolicyPage() {

  return <PolicyEmbed title="Privacy Policy"
                      src="https://app.termly.io/policy-viewer/policy.html?policyUUID=17afab85-64a4-411e-8248-3acc224f0214"
                      height={15100} />

}
